module.exports = __webpack_public_path__ + "img/下载.d687f8a5.png";